import {
	IBookingCreateRequestData,
	IBookingRequestAncillary,
} from '../../../../../shared/api/gateway/types/IBookingCreateRequestData';
import { toLocalDateTime } from '../../../../../shared/i18n/date-time/LocalDateTime';
import { IAncillary } from '../../../ancillary/domain/models/IAncillary';
import { getTimeIn24HourFormat } from '../../../utils/getTimeIn24HourFormat';
import { IBooking } from '../../models/IBooking';
import { NewBooking } from '../../models/NewBooking';

export function adaptBookingCreateData(
	booking: NewBooking,
	parkingProductsQuoteKey: string | undefined,
	originalBooking?: IBooking,
): IBookingCreateRequestData | undefined {
	const {
		entryDate,
		entryTime,
		exitDate,
		exitTime,
		promoCode,
		parkingProduct,
		ancillaries,
		personalDetails,
		emailOptIn,
		vehicleDetails,
		travelDetails,
		paymentDetails,
	} = booking;

	if (
		!entryDate ||
		!exitDate ||
		!parkingProductsQuoteKey ||
		!parkingProduct ||
		!personalDetails ||
		!vehicleDetails
	) {
		return undefined;
	}

	const requiresPayment = booking.totalPrice.centAmount > 0;

	if (requiresPayment && !paymentDetails) {
		return undefined;
	}

	return {
		originalBooking: originalBooking
			? {
					reference: originalBooking.reference,
					email: originalBooking.personalDetails.email,
			  }
			: undefined,
		parkingProductsQuote: {
			key: parkingProductsQuoteKey,
			startDate: toLocalDateTime(entryDate).date,
			startTime: entryTime ?? getTimeIn24HourFormat(entryDate),
			endDate: toLocalDateTime(exitDate).date,
			endTime: exitTime ?? getTimeIn24HourFormat(exitDate),
			promoCode,
		},
		parkingProduct: {
			id: parkingProduct.id,
			price: parkingProduct.price.value.toString(),
		},
		ancillaries: adaptAncillaries(ancillaries),
		personalDetails,
		emailOptIn,
		vehicleDetails,
		travelDetails,
		paymentDetails:
			requiresPayment && paymentDetails
				? {
						token: paymentDetails.token,
						tokenType: paymentDetails.tokenType,
						total: booking.totalPrice.toString(),
				  }
				: undefined,
	};
}

function adaptAncillaries(
	ancillaries: IAncillary[],
): IBookingRequestAncillary[] {
	return ancillaries.map((ancillary) => ({
		id: ancillary.id,
		price: ancillary.price?.toString(),
		extras: ancillary.extras
			?.filter((extra) => extra.variants.length)
			.map((extra) => ({
				id: extra.id,
				variants: extra.variants.map((variant) => ({
					id: variant.id,
					price: variant.price.toString(),
				})),
			})),
	}));
}
